export default function SVG_Patterns() {
  return (
    <div>
      <h1>SVG_Patterns Component</h1>
    </div>
  );
}
